import "../scss/page.scss";

import "../scss/ehealth.scss";

import "./scripts/ehealth/header.js";
import "./scripts/matchHeight/ehealth.js";
import "./scripts/ehealth/hero.js";
import "./scripts/ehealth/systems.js";
import "./scripts/ehealth/foryour.js";
import "./scripts/backstage";

import "./scripts/slick/parallax.js";
import "./scripts/slick/ehealth.js";

import "./scripts/animatenumber.js";

import * as bootstrap from 'bootstrap';
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))